// extracted by mini-css-extract-plugin
export default {"signinastext":"SignUpForm_signinastext__NW1q2","signintype":"SignUpForm_signintype__M0V5x","signupp":"SignUpForm_signupp__RIgq9"};